
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-growth-yield-prediction",
      function () {
        return require("private-next-pages/health-growth-yield-prediction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-growth-yield-prediction"])
      });
    }
  